import Blue from '~/core'
import { toggle as Toggle } from '../plugins'

new Blue({
  name: 'site modals',
  selector: '.site-modals__modal--cookies',
  setup(cookies) {
    const closeBtn = cookies.querySelector('.site-modals__modal-close')
    const accept = cookies.querySelector('.site-modals__modal-accept')
    const decline = cookies.querySelector('.site-modals__modal-decline')
    const storage = window.localStorage

    const onAccept = new CustomEvent('accepted')
    const onDecline = new CustomEvent('declined')

    const checkForResponse = () => JSON.parse(storage.getItem('acceptedCookies'))

    const toggle = new Toggle({
      content: cookies,
    })

    const closeCookies = () => {
      toggle.close()
      closeBtn.removeAttribute('tabindex')
      accept.removeAttribute('tabindex')
      decline.removeAttribute('tabindex')
    }
    const openCookies = () => {
      toggle.open()
      closeBtn.setAttribute('tabindex', 1)
      accept.setAttribute('tabindex', 1)
      decline.setAttribute('tabindex', 1)
      closeBtn.focus()
    }

    const setCookies = (consent) => {
      storage.setItem('acceptedCookies', consent)

      if (consent) accept.dispatchEvent(onAccept)
      else decline.dispatchEvent(onDecline)

      closeCookies()
    }

    this.$addEvents(closeBtn, 'click enter', closeCookies)
    this.$addEvents(decline, 'click enter', () => setCookies(false))
    this.$addEvents(accept, 'click enter', () => setCookies(true))

    setTimeout(() => {
      if (checkForResponse() !== null) return
      openCookies()
    }, 750)
  },
})
